import { useMutation } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../lib/enums";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";

const COPY_TO_SUBMISSIONS_QUERY_KEY = ["copyToMySubmissionQueryKey"];

type Payload = {
  fileName: string;
  userName: string;
  sourceId: number;
};

const useCopyToMySubmissions = () => {
  const { mutate } = useMutation({
    mutationKey: COPY_TO_SUBMISSIONS_QUERY_KEY,
    mutationFn: ({ sourceId }: Payload) =>
      api.copyUploadedSampleToMySubmissions(sourceId),
    onMutate: ({ fileName, userName }) => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: `Copying ${fileName} to ${userName}'s submissions`
      });
    },
    onSuccess: (_, { fileName, userName }) => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: `${fileName} copied to ${userName}'s submissions`
      });
    },
    onError: (_, { fileName, userName }) => {
      show({
        level: NotificationsLevel.ERROR,
        message: `Failed to copy ${fileName} to ${userName}'s submissions`
      });
    }
  });

  return { mutate };
};

export default useCopyToMySubmissions;
